// Shared category list used by the public portfolio page and the admin
// portfolio uploader. Slugs MUST match the PROJECT_CATEGORIES constant in
// /app/backend/models.py.
export const PORTFOLIO_CATEGORIES = [
  { slug: "roofing", label: "Roofing" },
  { slug: "remodeling", label: "Remodeling" },
  { slug: "outdoor-living", label: "Outdoor Living" },
  { slug: "exterior", label: "Exterior" },
  { slug: "repairs", label: "Repairs" },
];

export const CATEGORY_BY_SLUG = Object.fromEntries(
  PORTFOLIO_CATEGORIES.map((c) => [c.slug, c])
);

export function categoryLabel(slug) {
  return CATEGORY_BY_SLUG[slug]?.label || slug;
}
